module.exports = new __parcel__URL__("PageInsightsGraph.5c19c532.svg").toString();